import {alias, createModelSchema, list} from "serializr";
import { BaseObject } from "@/common/BaseObject";
import { Schema } from "@/common/Schema";

import { GuardConfig } from "../guard/GuardConfig";
import { CurrencyFormula } from "@/modules/redactor/models/currency/CurrencyFormula";
import { CurrencyDeprecate } from "@/modules/redactor/models/currency/CurrencyDeprecate";
import { SearchModel } from "@/modules/redactor/models/search/SearchModel";
import { ItemKey } from "@/modules/redactor/models/item/core/ItemKey";
import {CurrencyGroupModel} from "@/modules/redactor/models/currency/CurrencyGroupModel";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {MapGroupModel} from "@/modules/redactor/models/map/MapGroupModel";


export class CurrencyConfig extends BaseObject {

    constructor() {
        super();
        this._kind = null;
        this._group = null;
        this._guard = new GuardConfig();
        this._order = 0;
        this._search = null;
        this._formulas = [];
        this._deprecate = null;
        this._customers = [];
        this._emitters = [];
        this._mapGroup = null;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get group() {
        return this._group;
    }

    set group(value) {
        this._group = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get order() {
        return this._order;
    }

    set order(value) {
        this._order = value;
    }

    get search() {
        return this._search;
    }

    set search(value) {
        this._search = value;
    }

    get formulas() {
        return this._formulas;
    }

    set formulas(value) {
        this._formulas = value;
    }

    get deprecate() {
        return this._deprecate;
    }

    set deprecate(value) {
        this._deprecate = value;
    }

    get customers() {
        return this._customers;
    }

    set customers(value) {
        this._customers = value;
    }

    get emitters() {
        return this._emitters;
    }

    set emitters(value) {
        this._emitters = value;
    }

    get mapGroup() {
        return this._mapGroup;
    }

    set mapGroup(value) {
        this._mapGroup = value;
    }

    valid() {
        if (!CurrencyKindModel.is(this.kind)) {
            console.log("CConf", this.kind);
            return false;
        }

        if (!CurrencyGroupModel.is(this.group)) {
            console.log("CConf 2", this.group);
            return false;
        }

        if (!Number.isInteger(this.order) || this.order < 0) {
            console.log("CConf 3", this.order);
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            console.log("CConf 4", this.guard);
            return false;
        }

        if (this.search && !this.search.valid()) {
            console.log("CConf 5", this.search);
            return false;
        }

        if (this.deprecate && !this.deprecate.valid()) {
            console.log("CConf 6", this.deprecate);
            return false;
        }

        if (this.customers.some(c => !c || !c.valid() || c.any())) {
            console.log("CConf 7", this.customers);
            return false;
        }

        if(this.emitters.some(e => !e || !e.valid() || e.any())) {
            console.log("CConf 8", this.emitters);
            return false;
        }

        return true;
    }

    empty() {
        return !this.kind;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new CurrencyConfig());
        } else if (target instanceof CurrencyConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(CurrencyConfig, {
    _kind: alias("kind", CurrencyKindModel.schema()),
    _group: alias("group", CurrencyGroupModel.schemaByCode()),
    _guard: alias("guard", GuardConfig.schema()),
    _order: alias("order", Schema.primitive()),
    _search: alias("search", SearchModel.schema()),
    _formulas: alias("formulas", list(CurrencyFormula.schema())),
    _deprecate: alias("deprecate", CurrencyDeprecate.schema()),
    _customers: alias("customers", list(ItemKey.schema())),
    _emitters: alias("emitters", list(ItemKey.schema())),
    _mapGroup: alias("map_group", MapGroupModel.schema()),
});


